import React from 'react';
import { MembershipBanner } from '@noths/polaris-client-ribbons-design-system';

import { trackCTAClick } from 'src/tracking/trackCTAClick';
import { trackImpression } from 'src/tracking/trackImpression';

const commonTrackingArgs = {
  category: 'Membership banner',
  contentType: 'membership banner|pdp-membership-banner-noths&more',
  label: 'pdp-membership-banner-noths&more',
};

export const MembershipBannerSection = () => {
  return (
    <MembershipBanner
      backgroundImageUrl="https://images.contentstack.io/v3/assets/blt63f2f7afd19b09c2/bltda8db62750e92379/68e3aae4b0493ac06bccdec9/noths-more-banner.jpg"
      buttonHref="/membership"
      buttonText="Tell me more"
      copy="Members get 10% off everything for a year – including sale and all your Christmas shopping!"
      heading="Save 10% on this item with a NOTHS & More membership"
      onButtonClick={(e) => trackCTAClick(e, commonTrackingArgs)}
      onVisible={() => trackImpression(commonTrackingArgs)}
    />
  );
};
